import { INFO_PANE_PAGES } from '../../redux_store';
import PatientInfo from './Pages/PatientInfo';
import Metrics from './Pages/Metrics';
import Program from './Pages/Program';

export const INFO_PANE_ROUTES = {
  [INFO_PANE_PAGES.patient_page]: <PatientInfo />,
  [INFO_PANE_PAGES.metrics]: <Metrics />,
  [INFO_PANE_PAGES.program]: <Program />,
};

export const INFO_PANE_SIZES = {
  full_width: 360,
  small_width: 45,
};
